// src/scripts/cursor-trail.ts
var CursorTrail = class {
  canvas;
  ctx;
  particles = [];
  mouseX = 0;
  mouseY = 0;
  constructor() {
    this.canvas = document.createElement("canvas");
    this.canvas.style.position = "fixed";
    this.canvas.style.left = "0";
    this.canvas.style.top = "0";
    this.canvas.style.width = "100%";
    this.canvas.style.height = "100%";
    this.canvas.style.pointerEvents = "none";
    this.canvas.style.zIndex = "9999";
    document.body.appendChild(this.canvas);
    const ctx = this.canvas.getContext("2d", { alpha: true });
    if (!ctx) throw new Error("Cannot get canvas context");
    this.ctx = ctx;
    this.ctx.imageSmoothingEnabled = true;
    this.ctx.imageSmoothingQuality = "high";
    this.resize();
    window.addEventListener("resize", () => this.resize());
    document.addEventListener("mousemove", this.onMouseMove.bind(this));
    requestAnimationFrame(this.animate.bind(this));
  }
  resize() {
    this.canvas.width = window.innerWidth;
    this.canvas.height = window.innerHeight;
  }
  onMouseMove(e) {
    this.mouseX = e.clientX;
    this.mouseY = e.clientY;
    this.emit(this.mouseX, this.mouseY);
  }
  emit(x, y) {
    if (Math.random() > 0.3) return;
    const burstCount = Math.random() > 0.6 ? 3 : 1;
    for (let i = 0; i < burstCount; i++) {
      const baseAngle = Math.PI;
      const angleSpread = Math.PI * 1.1;
      const angle = baseAngle + (Math.random() - 0.5) * angleSpread;
      const radius = 0.5 + Math.random() * 0.8;
      const speed = 0.8 + Math.random() * 2;
      const life = 120 + Math.random() * 80;
      const spawnOffset = 3 + Math.random() * 5;
      this.particles.push({
        x: x + Math.cos(angle) * spawnOffset,
        y: y + Math.sin(angle) * spawnOffset,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        life,
        maxLife: life,
        radius,
        hue: 45,
        flickerOffset: Math.random() * Math.PI * 2
      });
    }
  }
  animate() {
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    this.ctx.globalCompositeOperation = "lighter";
    const friction = 0.98;
    const time = performance.now() * 2e-3;
    for (let i = this.particles.length - 1; i >= 0; i--) {
      const particle = this.particles[i];
      if (!particle) return;
      particle.vx *= friction;
      particle.vy *= friction;
      particle.x += particle.vx;
      particle.y += particle.vy;
      const lifePct = particle.life / particle.maxLife;
      const fadeIn = Math.min(1, lifePct * 3);
      const fadeOut = Math.min(1, lifePct * 2);
      const flicker = 0.8 + 0.2 * Math.sin(time + particle.flickerOffset);
      const alpha = fadeIn * fadeOut * flicker;
      this.drawGlow(particle, alpha);
      particle.life--;
      if (particle.life <= 0) this.particles.splice(i, 1);
    }
    this.ctx.globalCompositeOperation = "source-over";
    if (this.particles.length > 200) {
      this.particles.splice(0, this.particles.length - 200);
    }
    requestAnimationFrame(this.animate.bind(this));
  }
  drawGlow(p, alpha) {
    const { x, y, radius, hue } = p;
    const gradient = this.ctx.createRadialGradient(x, y, 0, x, y, radius * 5);
    gradient.addColorStop(0, `hsla(${hue}, 100%, 90%, ${alpha})`);
    gradient.addColorStop(0.3, `hsla(${hue}, 100%, 80%, ${alpha * 0.5})`);
    gradient.addColorStop(0.6, `hsla(${hue}, 100%, 70%, ${alpha * 0.2})`);
    gradient.addColorStop(1, `hsla(${hue}, 100%, 70%, 0)`);
    this.ctx.fillStyle = gradient;
    this.ctx.beginPath();
    this.ctx.arc(x, y, radius * 5, 0, Math.PI * 2);
    this.ctx.fill();
  }
};

// src/scripts/mouse-pursuer.ts
var MousePursuer = class {
  node;
  originalPosition;
  position;
  target;
  maxSpeed;
  height;
  width;
  trail;
  constructor({ node, enableTrail = false }) {
    this.node = node;
    const { x, y, width, height } = node.getBoundingClientRect();
    this.originalPosition = { x, y };
    this.height = height;
    this.width = width;
    this.position = { x: 0, y: 0 };
    this.target = { x, y };
    this.maxSpeed = 10;
    document.addEventListener("mousemove", this.handleMouseMove.bind(this));
    this.create();
    this.update();
    if (enableTrail) {
      this.trail = new CursorTrail();
    }
  }
  handleMouseMove({ clientX, clientY }) {
    this.target.x = clientX;
    this.target.y = clientY;
    if (this.trail) this.trail.emit(clientX, clientY);
  }
  create() {
    this.node.classList.add("relative", "transition-all", "ease-out", "left-[--position-x]", "top-[--position-y]");
  }
  update() {
    this.position.x = this.target.x - this.width / 2;
    this.position.y = this.target.y - this.height / 2;
    this.node.style.setProperty("--position-x", `${this.position.x}px`);
    this.node.style.setProperty("--position-y", `${this.position.y}px`);
    requestAnimationFrame(this.update.bind(this));
  }
};
document.querySelectorAll("[data-mouse-pursuer]").forEach((template) => {
  if (!(template instanceof HTMLElement)) return;
  const clone = template.cloneNode(true);
  clone.style.display = "";
  document.body.appendChild(clone);
  new MousePursuer({ node: clone, enableTrail: !!template.dataset.cursorTrail });
});
